import { useContext, useMemo } from 'react';

import { UserPreferencesContext } from '../userPreferenceContext';
import { deriveEffectiveTaxonomiesForScope } from '../utils/derive-effective-taxonomies';

export function useActivityTaxonomy(): number | undefined {
  const { preferences, scope } = useContext(UserPreferencesContext);

  const selection = useMemo(() => {
    const taxonomies =
      deriveEffectiveTaxonomiesForScope(preferences.taxonomies, scope) || {};
    const activityPref = taxonomies?.activity;
    const effectiveActivityPref =
      taxonomies?.effectiveActivityTaxonomySelection;

    if (!activityPref) return 0;

    if (activityPref === 'adaptive') {
      if (
        typeof effectiveActivityPref === 'number' &&
        effectiveActivityPref > 0
      ) {
        return effectiveActivityPref;
      }
      return undefined;
    }

    if (typeof activityPref === 'number') return activityPref;
    return 0;
  }, [preferences, scope]);

  return selection;
}
